import {ROLE} from "../components/aside/entity";

export const getRoleFlags = (role) => {
  return {
    isNormalUser: role === ROLE.NORMAL,
    isAdminUser: role === ROLE.ADMIN,
    isSuperAdminUser: role === ROLE.SUPER_ADMIN,
    isAdminLevelUser: [ROLE.ADMIN, ROLE.SUPER_ADMIN].includes(role),
  };
};